/// <reference path="../../typings/index.d.ts" />

module monitoringApp.common {

    interface IFormResult {
        redirectURL?: string,
        modalMessage?: string

    }

    export class FormService {
        static $inject = ["$http"];
        constructor(private $http: ng.IHttpService) { }
        submitForm(url: string, formData: {}): ng.IHttpPromise<IFormResult> {
            
            return this.$http({
                method: 'POST',
                url: url,
                data: $.param(formData),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((result) => {
                var r = <IFormResult>result.data;
                if (r.redirectURL) {
                    window.location.href = r.redirectURL;
                    return null;
                }
                return result.data;
            });
        }
    }

    angular.module('common.services').service('formService', monitoringApp.common.FormService);
}
